const stringHash = (mystring: string): string => {
  let hash = 0,
    i,
    chr
  if (mystring.length === 0) {
    return String(hash)
  }
  for (i = 0; i < mystring.length; i++) {
    chr = mystring.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0 // Convert to 32bit integer
  }
  return String(hash)
}

export function capitalize(str: string | number): string {
  if (!str || typeof str !== 'string') {
    return String(str)
  }
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function lowerFirst(str: string | number): string {
  if (!str || typeof str !== 'string') {
    return String(str)
  }
  return str.charAt(0).toLowerCase() + str.slice(1)
}

export { stringHash }

export type StringKeys<T> = {
  [K in keyof T]: T[K] extends string ? K : never
}[keyof T]
